import { render, staticRenderFns } from "./RevenueBreakupDialog.vue?vue&type=template&id=cdba24dc"
import script from "./RevenueBreakupDialog.vue?vue&type=script&lang=js"
export * from "./RevenueBreakupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports